import { Controller, useFormContext } from 'react-hook-form';
import { MultiselectQuestionProps } from '../../types';
import { SelectOption } from '../components/select-option';

export const MultiselectQuestion = ({ question }: MultiselectQuestionProps) => {
  const { control, clearErrors } = useFormContext();

  // Calculate options count including default options if none exist
  // HACK ALERT: every multiselect or select question must have at least 2 opts, this is to catch questions that have none
  const effectiveOptions =
    question.options && question.options.length > 0
      ? question.options
      : [
          { slug: 'yes', displayText: 'Yes' },
          { slug: 'no', displayText: 'No' },
        ];
  const optionsCount = effectiveOptions.length;
  const shouldUseGrid = optionsCount > 5;
  const NONE_OPTIONS = ['none', '', 'none-of-the-above'];
  return (
    <Controller
      control={control}
      name={question.slug}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const currentValues = Array.isArray(value) ? value : [];

        const handleChange = (optionSlug: string) => {
          const isCurrentlySelected = currentValues.includes(optionSlug);
          let newValues: string[];
          const isNoneOption = NONE_OPTIONS.includes(optionSlug);

          if (isCurrentlySelected) {
            newValues = currentValues.filter((v) => v !== optionSlug);
          } else {
            if (isNoneOption) {
              newValues = [optionSlug];
            } else {
              const filteredValues = currentValues.filter((v) => !NONE_OPTIONS.includes(v));
              newValues = [...filteredValues, optionSlug];
            }
          }

          onChange(newValues);
          clearErrors(question.slug);
        };


        return (
          <div className="questionnaire-question-content">
            <div className="select-question-container">
              <div className={`${shouldUseGrid ? 'select-options-grid' : 'select-options-list'}`}>
                {effectiveOptions.map((option) => (
                  <SelectOption
                    key={option.slug}
                    option={option}
                    value={currentValues.includes(option.slug) ? option.slug : ''}
                    handleChange={() => handleChange(option.slug)}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};
